import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/recipes";

export const fetchRecipes = createAsyncThunk("recipe/fetchAll", async (params?: string): Promise<any> => {
  const query = params ? `?${params}` : "";
  const response = await axios.get(`${BASE}${query}`);
  return response.data;
});

export const fetchRecipeById = createAsyncThunk("recipe/fetchById", async (id: string): Promise<any> => {
  const response = await axios.get(`${BASE}/${id}`);
  return response.data;
});

export const addRecipe = createAsyncThunk("recipe/add", async (payload: any): Promise<any> => {
  const response = await axios.post(BASE, payload);
  return response.data;
});

export const updateRecipe = createAsyncThunk("recipe/update", async ({ id, payload }: any): Promise<any> => {
  const response = await axios.put(`${BASE}/${id}`, payload);
  return response.data;
});

export const deleteRecipe = createAsyncThunk("recipe/delete", async (id: string): Promise<any> => {
  const response = await axios.delete(`${BASE}/${id}`);
  return response.data;
});
